import React from 'react';
import ChromaGrid from './ChromaGrid'; 
import './Memories.css'

const Developers = () => {
  // Array of items to be displayed in the grid
  const items = [
    {
      image: "/Developers/harshit.png",
      title: "Harshit",
      subtitle: "",
      handle: "@harshiii25",
      borderColor: "#3B82F6",
      gradient: "linear-gradient(145deg, #4d91ffff, #1E1E1E)",
      url: "https://github.com/harshiii25"
    },
    {
      image: "/Developers/savar.png",
      title: "Savar",
      subtitle: "",
      handle: "@savargit09",
      borderColor: "#f9f636ff",
      gradient: "linear-gradient(180deg, #eefa41ff, #1E1E1E)",
      url: "https://github.com/savargit09"
    },
    {
      image: "/Developers/lakshya.png",
      title: "Lakshya",
      subtitle: "",
      handle: "@2005lakshya",
      borderColor: "#a23cf6ff",
      gradient: "linear-gradient(180deg, #7928d0ff, #1E1E1E)",
      url: "https://github.com/2005lakshya"
    },
    {
      image: "/Developers/bhavya.png",
      title: "Bhavya",
      subtitle: "",
      handle: "@bhavya-khatri-59",
      borderColor: "#4dfd3dff",
      gradient: "linear-gradient(180deg, #5ce939ff, #1E1E1E)",
      url: "https://github.com/bhavya-khatri-59"
    },
    {
      image: "/Developers/tarush.png",
      title: "Tarush",
      subtitle: "",
      handle: "@tarush10000",
      borderColor: "#fd3d3dff",
      gradient: "linear-gradient(180deg, #ff5050ff, #1E1E1E)",
      url: "https://github.com/tarush10000"
    },
    {
      image: "/Developers/shrishti.png",
      title: "Shrishti",
      subtitle: "",
      handle: "@shrishtib07",
      borderColor: "#3dfdfdff",
      gradient: "linear-gradient(180deg, #7de7ffff, #1E1E1E)",
      url: "https://github.com/shrishtib07"
    },
    {
      image: "/Developers/naman.jpeg",
      title: "Naman",
      subtitle: "",
      handle: "@Naman080706",
      borderColor: "#ff8c1aff",
      gradient: "linear-gradient(180deg, #ff9d3cff, #1E1E1E)",
      url: "https://github.com/Naman080706"
    },
    {
      image: "/Developers/vrisha.jpeg",
      title: "Vrisha",
      subtitle: "",
      handle: "@vrisha06",
      borderColor: "#ff4dccff",
      gradient: "linear-gradient(180deg, #ff66d4ff, #1E1E1E)",
      url: "https://github.com/vrisha06"
    },
    {
      image: "/Developers/gaurav.jpeg",
      title: "Gaurav",
      subtitle: "",
      handle: "@gauravm0410",
      borderColor: "#14b8a6ff",
      gradient: "linear-gradient(180deg, #2dd4bfff, #1E1E1E)",
      url: "https://github.com/gauravm0410"
    },
    {
      image: "/Developers/Saksham.jpeg",
      title: "Saksham",
      subtitle: "",
      handle: "@Saksham0025",
      borderColor: "#6366f1ff",
      gradient: "linear-gradient(180deg, #818cf8ff, #1E1E1E)",
      url: "https://github.com/Saksham0025"
    },
    {
      image: "/Developers/rohan.jpeg",
      title: "Rohan",
      subtitle: "",
      handle: "@shresthrohan",
      borderColor: "#84cc16ff",
      gradient: "linear-gradient(180deg, #a3e635ff, #1E1E1E)",
      url: "https://github.com/shresthrohan"
    }
  ];

  return (
    <div style={{ height: '800px', position: 'relative' }}>
        
      <ChromaGrid 
        items={items}
        radius={200}
        damping={0.45}
        fadeOut={0.6}
        ease="power3.out"
      />
    </div>
  );
};

export default Developers;